const vuexInit = {
    indexTab2 : [{
      id: 1,
      name: '推荐',
      path: 'index2'
    },{
      id: 2,
      name: '系统课',
      path: 'listsystem'
    },{
      id: 3,
      name: '国培课',
      path: 'listnational'
    },{
      id: 4,
      name: '资格认证',
      path: 'listqualification'
    },{
      id: 5,
      name: '特训营',
      path: 'listspecial'
    },{
      id: 6,
      name: '陪跑计划',
      path: 'listaccompany'
    },{
      id: 7,
      name: '继续教育',
      path: 'listcontinuing'
    },{
      id: 8,
      name: '家长研修社',
      path: 'index'
    },{
      id: 9,
      name: '直播',
      path: 'live'
    },
    // {
    //   id: 10,
    //   name: '短视频',
    //   path: 'media'
    // }
  ],
    indexTab : [{
        id: 1,
        name: '推荐',
        path: 'index'
      }, 
      // {
      //   id: 2,
      //   name: '培训',
      //   path: 'train'
      // }, 
      {
        id: 3,
        name: '基础课程',
        path: 'lesson',
      },
      {
        id: 32,
        name: 'VIP课程',  //家长研修社
        path: 'lesson'
      },
      {
        id: 6,
        name: '短视频',
        path: 'media'
      },
      {
        id: 5,
        name: '直播',
        path: 'live'
      }, 
    //   {
    //     id: 4,
    //     name: '锦囊',
    //     path: 'idea'
    //   },
    ],
      
    platMap : {'daojia': {
        id: 120,
        name: "到家高研院",
        logo: '',
        faviconurl: '',
        indexData: [{
          category_name: "园所活动",
        },
        {
          category_name: "游戏方案",
        },
        {
          category_name: "环境创设",
        },
        {
          category_name: "手工活动",
        },
        {
          category_name: "音乐",
        },
        {
          category_name: "食谱",
        },
        {
          category_name: "绘本",
        },
        {
          category_name: "特色课程",
        },
        {
          category_name: "体育游戏",
        },
        {
          category_name: "全部分类",
        },
        ],
      },
      'tuoyu': {
        priceHide: true,
        id: 119,
        name: "托育从业人员培训平台",
        logo: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/tuoyuLogo.png',
        faviconurl: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/tuoyu/favicon_tuoyu.ico',
        indexData: [{
          category_name: "园所活动",
        },
        {
          category_name: "游戏方案",
        },
        {
          category_name: "环境创设",
        },
        {
          category_name: "手工活动",
        },
        {
          category_name: "音乐",
        },
        {
          category_name: "食谱",
        },
        {
          category_name: "绘本",
        },
        {
          category_name: "特色课程",
        },
        {
          category_name: "体育游戏",
        },
        {
          category_name: "全部分类",
        },
        ],
      },
      'youjiao': {
        id: 118,
        name: "幼教高研院",
        logo: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/tuoyu/youjiaologo.png',
        faviconurl: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/tuoyu/favicon_jingxue.ico',
        indexData: [{
          category_name: "园所活动",
        },
        {
          category_name: "游戏方案",
        },
        {
          category_name: "环境创设",
        },
        {
          category_name: "手工活动",
        },
        {
          category_name: "音乐",
        },
        {
          category_name: "食谱",
        },
        {
          category_name: "绘本",
        },
        {
          category_name: "特色课程",
        },
        {
          category_name: "体育游戏",
        },
        {
          category_name: "全部分类",
        },
        ],
      },
      'yingyou': {
        id: 171,
        name: "婴幼高研院",
        logo: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E2%9E%A4%E6%A0%87%E9%A2%98%402x.png',
        faviconurl: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/tuoyu/favicon_tuoyu.ico'
      },
      'jiazhang03': {
        id: 121,
        name: "家长学堂",
        // logo: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/zhongtuo/zhongtuojiazhangLogo5.png',
        logo: './jiazhang03.png',
        faviconurl: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/tuoyu/favicon_chongdong.ico'
      },
      'jiazhang06': {
        id: 107,
        name: "家长研修社",
        logo: 'https://cdnsaas.amfakids.cn/miniprogram/study_center/tuoyu2/logo06_bak.png',
        faviconurl: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/tuoyu/favicon_chongdong.ico'
      }}
}
export default vuexInit